import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { map, catchError } from "rxjs/operators";
import { InformacionInicioDto } from "../models/informacion-inicio-dto";
import { environment } from "../../../environments/environment";

@Injectable()
export class InicioService {
  private inicioEndPoint = environment.inicioEndPoint;

  constructor(private http: HttpClient) {}

  informacionInicialPorIp(): Observable<InformacionInicioDto> {
    return this.http.get<InformacionInicioDto>(this.inicioEndPoint + "/ipSede");
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/inicio.service.ts